import { create } from 'zustand';
type Toast = { id: string; message: string; tone: 'success' | 'error' | 'info' };
type Store = {
  toasts: Toast[];
  addToast: (message: string, tone?: Toast['tone']) => void;
  removeToast: (id: string) => void;
  theme: 'light' | 'dark';
  toggleTheme: () => void;
  setTheme: (theme: 'light' | 'dark') => void;
};
export const useAppStore = create<Store>((set, get) => ({
  toasts: [],
  theme: (localStorage.getItem('quizroom_theme') as 'light' | 'dark') || 'light',
  addToast: (message, tone = 'info') => {
    const id = crypto.randomUUID();
    set({ toasts: [...get().toasts, { id, message, tone }] });
    setTimeout(() => get().removeToast(id), 4500);
  },
  removeToast: (id) => set({ toasts: get().toasts.filter((x) => x.id !== id) }),
  toggleTheme: () => {
    const theme = get().theme === 'light' ? 'dark' : 'light';
    localStorage.setItem('quizroom_theme', theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
    set({ theme });
  },
  setTheme: (theme) => {
    localStorage.setItem('quizroom_theme', theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
    set({ theme });
  },
}));
